//@DEPRECATED
import { FC, useMemo } from 'react';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import { styled } from '@mui/system';

import { WordBreak } from 'src/components';
import { TAIForm, ISummary, IMaterial } from 'src/types';
import { formatDate } from 'src/utils';

const MaterialList = styled('ul')`
  list-style: none;
  padding-left: 8px;
`;

interface AttachmentListProps {
  data: ISummary | TAIForm;
  fieldPath?: string;
}

const AttachmentList: FC<AttachmentListProps> = ({ data, fieldPath }) => {
  const materialsList = useMemo(() => {
    const materials: IMaterial[] = data?.materials as IMaterial[] || [];
    return materials.filter((each) => {
      if (!fieldPath) {
        return !each.fieldPath;
      } else {
        return each.fieldPath === fieldPath;
      }
    });
  }, [data?.materials, fieldPath]);

  return (
    <MaterialList>
      {materialsList?.map((material: any, i: number) => (
        <li className="display-flex align-items-xs-center" key={material.fileName + material.updateDate + fieldPath + i}>
          <AttachFileIcon />
          <div>
            <a className="cb-link-blue cb-link-default" href={material.preSigned} target="_blank" rel="noreferrer">
              {material.fileName}
            </a>
            <WordBreak>
              <WordBreak>{material.description}</WordBreak>
              <WordBreak>Uploaded: {formatDate(material?.updateDate || material?.time)}</WordBreak>
            </WordBreak>
          </div>
        </li>
      ))}
    </MaterialList>
  );
};

export default AttachmentList;
